import React, { Component } from 'react'
import {defineMessages, FormattedDate, FormattedMessage, FormattedNumber, injectIntl} from "react-intl"
import PaymentTypeIcon from "../../../../invoice/paymenttypeicon.component.jsx";
import ProposalMergeFields from "../../../MergeFields.jsx";
import PaymentTypeLabel from "../../../../payment/label.component.jsx";
import OnlinePaymentReceiptSection from '../../../../payment/onlinepaymentreceiptsection.component'
import { ConvertPaymentToOnlinePaymentReceipt } from '../../../../state/helpers/OnlinePaymentReceipt'
import { PAYMENT_STATUS } from '../../../../state/helpers/Payment';
import { DEPOSIT_TYPE } from '../../../../state/pricing/DepositTypes'
import TotalQuantityHelper from '../../../../common/pricing/TotalQuantityHelper';

const messages = defineMessages({
    "grouped_quantity_unit": {
        id: "templates.sections.form.edit.content.pricing_table.grouped_quantity_unit",
        defaultMessage: "Total number of units",
    },
    "grouped_quantity_time": {
        id: "templates.sections.form.edit.content.pricing_table.grouped_quantity_time",
        defaultMessage: "Total time",
    },
})

class DocumentPricingTableTotal extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            total: this.props.total || null,
            isPdf: this.props.isPdf === true,
            showTaxes: this.props.showTaxes === true,
            showTotalQuantitiesByUnitGroup: this.props.showTotalQuantitiesByUnitGroup === true,
            unitGroupsToDisplay: this.props.unitGroupsToDisplay || [],
            hideDeposit: this.props.hideDeposit === true,
            hideDueDate: this.props.hideDueDate === true,
            depositRatio: this.props.depositRatio || 0,
            depositAmount: this.props.depositAmount || '0',
            depositBalance: this.props.depositBalance || 0,
            dueDate: this.props.dueDate || '',
            balance: this.props.balance || '0',
            payments: this.props.payments || [],
            invoices: this.props.invoices || [],
            proposalType: this.props.proposalType || '',
            variables: this.props.variables || {},
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            total: nextProps.total || null,
            showTaxes: nextProps.showTaxes === true,
            showTotalQuantitiesByUnitGroup: nextProps.showTotalQuantitiesByUnitGroup === true,
            unitGroupsToDisplay: nextProps.unitGroupsToDisplay || [],
            hideDeposit: nextProps.hideDeposit === true,
            hideDueDate: nextProps.hideDueDate === true,
            isPdf: nextProps.isPdf === true,
            depositRatio: nextProps.depositRatio || 0,
            depositBalance: nextProps.depositBalance || 0,
            depositAmount: nextProps.depositAmount || '0',
            balance: nextProps.balance || '0',
            payments: nextProps.payments || [],
            invoices: nextProps.invoices || [],
            proposalType: nextProps.proposalType || '',
            variables: nextProps.variables || {},
        })
    }

    getPaymentTypeIcon(paymentTransaction) {
        return paymentTransaction.attributes.payment.attributes.paymentType ?
            paymentTransaction.attributes.payment.attributes.paymentType.attributes.icon : ''
    }

    getOrderPaymentDetails(totals, pay) {
        const getDepositMessage = () => {
            return parseFloat(pay.amount) >= 0 ?
                <FormattedMessage
                    id="order_deposit.edit.numbers.deposit_on"
                    defaultMessage="Deposit on {object}"
                    values={{
                        object: <a target={'_blank'} href={'/p/proposals/' + pay.objectProposalHash}>
                            {pay.objectIdentifier}
                        </a>,
                        referenceIdentifier: pay.referenceIdentifier,
                    }}
                />
                :
                <small>
                    <FormattedMessage
                        id="order_deposit.edit.numbers.deposit_refunded_on"
                        defaultMessage="Refund on {referenceIdentifier}"
                        values={{
                            referenceIdentifier: pay.referenceIdentifier,
                        }}
                    />
                </small>
        }

        const className = (parseFloat(pay.amount) >= 0 ? 'mt-3 mb-0' : 'my-1')
        const formattedDate = <span className="ml-2">
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(pay.createdAt)}
            />
        </span>

        return [
            <dd className={"col-sm-8 " + className} key={totals.length}>
                {
                    ['quotes', 'orders', 'price-lists'].includes(pay.objectType) ?
                        <div className="flex flex-column">
                            {getDepositMessage()}
                            <div>
                                {
                                    pay.createdAt &&
                                    <small>
                                        <PaymentTypeIcon value={pay.paymentType} className={'mr-1'} />
                                        <PaymentTypeLabel value={pay.paymentType} />
                                        {
                                            pay.creditCardDetails &&
                                            <span className="ml-1 text-uppercase">
                                                {pay.creditCardDetails.attributes.brand} {pay.creditCardDetails.attributes.last4}
                                            </span>
                                        }
                                        {formattedDate}
                                    </small>
                                }
                            </div>
                        </div>
                        :
                        <div className="flex flex-column">
                            <FormattedMessage
                                id="quote.edit.numbers.payment_on"
                                defaultMessage="Payment on {object}"
                                values={{
                                    object: <a target={'_blank'} href={'/p/proposals/' + pay.objectProposalHash}>
                                        {pay.objectIdentifier}
                                    </a>,
                                }}
                            />
                            <div>
                                {pay.createdAt &&
                                    <small>
                                        <PaymentTypeIcon value={pay.paymentType} className={'mr-1'} />
                                        <PaymentTypeLabel value={pay.paymentType} />
                                        {formattedDate}
                                    </small>
                                }
                            </div>
                        </div>
                }
            </dd>,
            <dd className={"col-sm-4 " + className}
                key={totals.length}>
                <FormattedNumber
                    style="currency"
                    currency={pay.currency}
                    value={pay.amount}
                />
            </dd>
        ]
    }

    getQuotePaymentDetails(totals, pay) {
        const isIntegratedCreditCardPayment = pay.payment.attributes.integratedPayment &&
            pay.payment.attributes.integratedPayment.attributes.creditCardDetails
        const creditCardBrand = isIntegratedCreditCardPayment ?
            pay.payment.attributes.integratedPayment.attributes.creditCardDetails.attributes.brand : ''
        const creditCardLast4 = isIntegratedCreditCardPayment ?
            pay.payment.attributes.integratedPayment.attributes.creditCardDetails.attributes.last4 : ''

        let depositLabel = <FormattedMessage
            id="order_deposit.edit.numbers.deposit_on"
            defaultMessage="Deposit on {object}"
            values={{
                object: <a target={'_blank'} href={'/p/proposals/' + this.state.variables.hash}>
                    {this.state.variables.quote.reference}
                </a>,
            }}
        />
        if (this.state.variables.global.fullPaymentAndCheckoutOnly) {
            depositLabel = <FormattedMessage
                id="quote.edit.numbers.payment_on"
                defaultMessage="Payment on {object}"
                values={{
                    object: <a target={'_blank'} href={'/p/proposals/' + this.state.variables.hash}>
                        {this.state.variables.quote.reference}
                    </a>,
                }}
            />
        }

        return [
            <dd className={"col-sm-8 mb-0 mt-2"} key={totals.length}>
                <div className="flex flex-column">
                    {depositLabel}
                    <div>
                        {pay.createdAt &&
                            <small>
                                <PaymentTypeIcon value={pay.payment.attributes.type} className={'mr-1'} />
                                <PaymentTypeLabel value={pay.payment.attributes.type} />
                                {
                                    isIntegratedCreditCardPayment &&
                                    <span className="ml-1 text-uppercase">
                                        {creditCardBrand} {creditCardLast4}
                                    </span>
                                }
                                <span className="ml-2">
                                    <FormattedDate
                                        year='numeric'
                                        month='long'
                                        day='numeric'
                                        value={new Date(pay.createdAt)}
                                    />
                                </span>
                            </small>
                        }
                    </div>
                </div>
            </dd>,
            <dd className={"col-sm-4 mb-0 mt-2"} key={totals.length}>
                <FormattedNumber
                    style="currency"
                    currency={pay.currency}
                    value={pay.amount}
                />
            </dd>,
        ]
    }

    getDisplayableTotalQuantityElements() {
        let elements = []
        for (let i = 0; i < this.state.unitGroupsToDisplay.length; i++) {
            const unitGroupToDisplaySelected = this.state.unitGroupsToDisplay[i]
            const quantityToDisplay = this.state.total.attributes.groupedQuantities
                .find(groupedQuantity => groupedQuantity.attributes.groupedQuantityType === unitGroupToDisplaySelected)

            if (!quantityToDisplay) {
                continue
            }

            const labelAndTotalQuantityValue = TotalQuantityHelper.getTotalQuantityLabelAndAmount(this.props.intl, quantityToDisplay)

            let marginClassName = ""
            if (i === this.state.unitGroupsToDisplay.length - 1) {
                marginClassName = "mb-3"
            }

            elements.push(
                <dt className={"col-sm-8 " + marginClassName} key={`total-quantity-label-${unitGroupToDisplaySelected}`}>
                    {labelAndTotalQuantityValue[0]}
                </dt>
            )
            elements.push(
                <dd className={"col-sm-4 " + marginClassName} key={`total-quantity-value-${unitGroupToDisplaySelected}`}>
                    {labelAndTotalQuantityValue[1]}
                </dd>
            )
        }

        return elements
    }

    render() {
        const mainTotalClassName = this.state.isPdf ? "" : ""
        let totals = []

        if (this.state.showTotalQuantitiesByUnitGroup) {
            totals.push(this.getDisplayableTotalQuantityElements())
        }

        if (this.state.showTaxes) {
            totals.push(
                <dt className="col-sm-8" key={totals.length}>
                    <FormattedMessage
                        id="proposal.items.quote_subtotal"
                        defaultMessage="Subtotal"
                    />
                </dt>
            )
            totals.push(
                <dd className="col-sm-4" key={totals.length}>
                    <FormattedNumber
                        style="currency"
                        currency={this.state.total.attributes.currency}
                        value={this.state.total.attributes.subtotalAmount}
                    />
                </dd>
            )

            if (this.state.total.attributes.isTaxInclusive) {
                for (let i in this.state.total.attributes.taxCalculations) {
                    const item = this.state.total.attributes.taxCalculations[i]
                    totals.push(
                        <dt className="col-sm-8" key={totals.length}>
                            {item.attributes.taxComponent.attributes.name}
                        </dt>
                    )
                    totals.push(
                        <dd className="col-sm-4" key={totals.length}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={item.attributes.taxAmount}
                            />
                        </dd>
                    )
                }
                if (this.state.total.attributes.isDiscounted) {
                    totals.push(
                        <dt className="col-sm-8" key={totals.length}>
                            <FormattedMessage
                                id="proposal.items.quote_subtotal"
                                defaultMessage="Subtotal"
                            />
                        </dt>
                    )
                    totals.push(
                        <dd className="col-sm-4" key={totals.length}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={this.state.total.attributes.totalAmountWithoutDiscount}
                            />
                        </dd>
                    )
                }
            }


            if (!this.state.total.attributes.isTaxInclusive && this.state.total.attributes.isDiscounted) {
                if (this.state.total && this.state.total.attributes && parseFloat(this.state.total.attributes.discountTotalAmount) > 0) {
                    totals.push(
                        <dt className="col-sm-8" key={totals.length}>
                            {this.state.total.attributes.discountName ? this.state.total.attributes.discountName : <FormattedMessage
                                id="proposal.items.quote_discount"
                                defaultMessage="Discount"
                            />}
                        </dt>
                    )
                    totals.push(
                        <dd className="col-sm-4" key={totals.length}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={-this.state.total.attributes.discountTotalAmount}
                            />
                        </dd>
                    )
                }
            }
            for (let i in this.state.total.attributes.feeCalculations) {
                const item = this.state.total.attributes.feeCalculations[i]
                if (parseFloat(item.attributes.amount) === 0) {
                    continue
                }
                totals.push(
                    <dt className="col-sm-8" key={totals.length}>
                        {item.attributes.fee.attributes.name}
                    </dt>
                )
                totals.push(
                    <dd className="col-sm-4" key={totals.length}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={item.attributes.amount}
                        />
                    </dd>
                )
            }
            if (this.state.total.attributes.isTaxInclusive && this.state.total.attributes.isDiscounted) {
                if (this.state.total && this.state.total.attributes && parseFloat(this.state.total.attributes.discountTotalAmount) > 0) {
                    totals.push(
                        <dt className="col-sm-8" key={totals.length}>
                            {this.state.total.attributes.discountName ? this.state.total.attributes.discountName :
                                <FormattedMessage
                                    id="proposal.items.quote_discount"
                                    defaultMessage="Discount"
                                />}
                        </dt>
                    )
                    totals.push(
                        <dd className="col-sm-4" key={totals.length}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={-this.state.total.attributes.discountTotalAmount}
                            />
                        </dd>
                    )
                }
            }
            //if (!this.state.total.attributes.isTaxInclusive && this.state.total.attributes.subtotalAmount !== this.state.total.attributes.totalAmountWithoutTax) {
            if (!this.state.total.attributes.isTaxInclusive && (this.state.total.attributes.feeCalculations.length > 0 || this.state.total.attributes.isDiscounted)) {
                totals.push(
                    <dt className="col-sm-8" key={totals.length}>
                        <FormattedMessage
                            id="proposal.items.quote_subtotal"
                            defaultMessage="Subtotal"
                        />
                    </dt>
                )
                totals.push(
                    <dd className="col-sm-4" key={totals.length}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={this.state.total.attributes.totalAmountWithoutTax}
                        />
                    </dd>
                )
            }
            if (!this.state.total.attributes.isTaxInclusive) {
                for (let i in this.state.total.attributes.taxCalculations) {
                    const item = this.state.total.attributes.taxCalculations[i]
                    totals.push(
                        <dt className="col-sm-8" key={totals.length}>
                            {item.attributes.taxComponent.attributes.name} {item.attributes.taxableAmount && <small>(<FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={item.attributes.taxableAmount}
                            /> @ {item.attributes.taxRate}%)</small>}
                        </dt>
                    )
                    totals.push(
                        <dd className="col-sm-4" key={totals.length}>
                            <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={item.attributes.taxAmount}
                            />
                        </dd>
                    )
                }
            }
            totals.push(
                <dt className={"col-sm-8 text-body mb-0 " + mainTotalClassName} key={totals.length}>
                    <FormattedMessage
                        id="proposal.items.quote_total"
                        defaultMessage="Total"
                    />
                </dt>
            )
            totals.push(
                <dd className={"col-sm-4 mb-0 text-body mb-0 " + mainTotalClassName} key={totals.length}>
                    <FormattedNumber
                        style="currency"
                        currency={this.state.total.attributes.currency}
                        value={this.state.total.attributes.totalAmount}
                    />
                </dd>
            )
        } else {
            if ((this.state.total.attributes.isDiscounted || this.state.total.attributes.feeCalculations.length > 0)) {
                totals.push(
                    <dt className="col-sm-8" key={totals.length}>
                        <FormattedMessage
                            id="proposal.items.quote_subtotal"
                            defaultMessage="Subtotal"
                        />
                    </dt>
                )
                totals.push(
                    <dd className="col-sm-4" key={totals.length}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={this.state.total.attributes.subtotalAmount}
                        />
                    </dd>
                )
            }
            if (this.state.total.attributes.isDiscounted) {
                totals.push(
                    <dt className="col-sm-8" key={totals.length}>
                        {this.state.total.attributes.discountName ? this.state.total.attributes.discountName : <FormattedMessage
                            id="proposal.items.quote_discount"
                            defaultMessage="Discount"
                        />}
                    </dt>
                )
                totals.push(
                    <dd className="col-sm-4" key={totals.length}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={-this.state.total.attributes.discountTotalAmount}
                        />
                    </dd>

                )
            }
            for (let i in this.state.total.attributes.feeCalculations) {
                const item = this.state.total.attributes.feeCalculations[i]
                totals.push(
                    <dt className="col-sm-8" key={totals.length}>
                        {item.attributes.fee.attributes.name}
                    </dt>
                )
                totals.push(
                    <dd className="col-sm-4" key={totals.length}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={item.attributes.amount}
                        />
                    </dd>
                )
            }
            totals.push(
                <dt className={"col-sm-8 text-body mb-0 " + mainTotalClassName} key={totals.length}>
                    <FormattedMessage
                        id="proposal.items.quote_total"
                        defaultMessage="Total"
                    />
                </dt>
            )
            totals.push(
                <dd className={"col-sm-4 mb-0 text-body mb-0 " + mainTotalClassName} key={totals.length}>
                    <FormattedMessage
                        id="proposal.items.plus_taxes"
                        defaultMessage="{amount} + Taxes"
                        values={{
                            amount: <FormattedNumber
                                style="currency"
                                currency={this.state.total.attributes.currency}
                                value={this.state.total.attributes.totalAmountWithoutTax}
                            />
                        }}
                    />
                </dd>
            )
        }
        if (this.state.total.attributes.billingMethod !== "one-time") {
            totals.push(
                <dt className="col-sm-8" style={{ lineHeight: 1 }} key={totals.length} />
            )
            let label = <FormattedMessage
                id="proposal.total.per_month_label"
                defaultMessage="per month"
            />
            if (this.state.total.attributes.billingMethod === "yearly") {
                label = <FormattedMessage
                    id="proposal.total.per_year_label"
                    defaultMessage="per year"
                />
            }
            totals.push(
                <dd className="col-sm-4 h5 mb-0" style={{ lineHeight: 1, color: 'gray' }} key={totals.length}>
                    <small>{label}</small>
                </dd>
            )
        }
        const hasDeposit = parseFloat(this.state.depositAmount) > 0 && this.state.total.attributes.billingMethod === "one-time" &&
            (this.state.variables && !this.state.variables.paymentSectionDisabled && !this.state.variables.global.fullPaymentAndCheckoutOnly)

        if (hasDeposit && !this.state.hideDeposit && this.state.depositBalance > 0) {
            totals.push(
                <dt className={"col-sm-8 mb-0 mt-2"} key={totals.length}>
                    <FormattedMessage
                        id="proposal.total.deposit"
                        defaultMessage="Deposit"
                    />
                </dt>
            )
            totals.push(
                <dd className={"col-sm-4 mb-0 mt-2"} key={totals.length}>
                    {parseFloat(this.state.depositRatio) > 0 && this.props.depositType != DEPOSIT_TYPE.FLAT_DEPOSIT ? <span className={'mr-1'}>
                        (<FormattedNumber
                            style="percent"
                            value={this.state.depositRatio}
                        />)
                    </span> : ''}
                    <FormattedNumber
                        style="currency"
                        currency={this.state.total.attributes.currency}
                        value={this.state.depositAmount}
                    />
                </dd>
            )
        }

        if (this.state.proposalType === 'credit-memo') {
            for (let i in this.state.payments) {
                const payment = this.state.payments[i]
                if (payment.attributes.payment.attributes.status === PAYMENT_STATUS.DECLINED) {
                    continue
                }

                const onlinePaymentReceipt = ConvertPaymentToOnlinePaymentReceipt(payment.attributes.payment, true)

                totals.push(
                    <div className="col-12 mt-4">
                        <div key={payment.id} className={'row d-flex flex-wrap justify-content-center mb-2'}>
                            <OnlinePaymentReceiptSection
                                payments={[onlinePaymentReceipt]}
                                variables={this.state.variables} />
                        </div>
                    </div>
                )
            }
        }

        if ((this.state.proposalType === 'invoice' && this.state.total.attributes.billingMethod === "one-time")) {
            for (let i in this.state.payments) {
                const payment = this.state.payments[i]
                if ([PAYMENT_STATUS.DECLINED, PAYMENT_STATUS.EXPIRED].includes(payment.attributes.payment.attributes.status)) {
                    continue
                }
                totals.push(
                    <dd className={"col-sm-8 mb-0 mt-2"} key={totals.length}>
                        <PaymentTypeIcon className={'mr-1'} value={payment.attributes.payment.attributes.type} icon={this.getPaymentTypeIcon(payment)} />
                        <FormattedMessage
                            id="proposal.total.payment_received"
                            defaultMessage="Payment on {date} {status}"
                            values={{
                                date: <FormattedDate
                                    year='numeric'
                                    month='long'
                                    day='numeric'
                                    timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                    value={new Date(payment.attributes.createdAt)} />,
                                status: payment.attributes.payment.attributes.status === PAYMENT_STATUS.PENDING ? `(${PAYMENT_STATUS.PENDING})` : ''
                            }}
                        />
                    </dd>
                )
                totals.push(
                    <dd className={"col-sm-4 mb-0 mt-2"} key={totals.length}>
                        <FormattedNumber
                            style="currency"
                            currency={payment.attributes.currency}
                            value={payment.attributes.amount}
                        />
                    </dd>
                )
            }
            totals.push(
                <dt className={"col-sm-8 mb-0 mt-2 text-body font-weight-bold"} key={totals.length}>
                    <p className={'mb-0'}>
                        <FormattedMessage
                            id="proposal.total.balance"
                            defaultMessage="Balance"
                        />
                    </p>
                </dt>
            )
            totals.push(
                <dd className={"col-sm-4 mb-0 mt-2 text-body font-weight-bold"} key={totals.length}>
                    <p className={'mb-0'}>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.total.attributes.currency}
                            value={this.state.balance}
                        />
                    </p>
                    {!this.state.hideDueDate && parseFloat(this.state.balance) > 0 ? <p className={'mb-0'}>
                        <small>
                            <FormattedMessage
                                id="proposal.total.balance_due_date"
                                defaultMessage="Due before {date}"
                                values={{
                                    date: <FormattedDate
                                        year='numeric'
                                        month='long'
                                        day='numeric'
                                        timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                        value={new Date(this.state.dueDate)}
                                    />
                                }}
                            />
                        </small>

                    </p> : ''}
                </dd>
            )
        }

        if (this.state.proposalType === 'quote') {
            {
                this.state.payments && this.state.payments.length > 0 &&
                    totals.push(
                        <dd className={"col-sm-12 mb-0 border-top mt-4 pt-2 text-body font-weight-bold"} key={totals.length}>
                            <p className={'mb-0'}>
                                <FormattedMessage
                                    id="proposal.total.order_received_payments"
                                    defaultMessage="Received Payments"
                                />
                            </p>
                        </dd>
                    )
            }
            for (let i in this.state.payments) {
                const pay = this.state.payments[i].attributes
                if (['declined', 'pending'].includes(pay.status)) {
                    continue
                }

                const quotePaymentDetails = this.getQuotePaymentDetails(totals, pay)
                totals.push(quotePaymentDetails[0])
                totals.push(quotePaymentDetails[1])
            }
        }

        if (this.state.proposalType === 'order' && this.state.total.attributes.billingMethod === "one-time" && this.state.variables.quote.receivedPayments && this.state.variables.quote.receivedPayments.length > 0) {
            totals.push(
                <dd className={"col-sm-12 mb-0 border-top mt-4 pt-2 text-body font-weight-bold"} key={totals.length}>
                    <p className={'mb-0'}>
                        <FormattedMessage
                            id="proposal.total.order_received_payments"
                            defaultMessage="Received Payments"
                        />
                    </p>
                </dd>
            )
            let balance = parseFloat(this.state.total.attributes.totalAmount ? this.state.total.attributes.totalAmount : 0)
            for (let i in this.state.variables.quote.receivedPayments) {
                const pay = this.state.variables.quote.receivedPayments[i]
                if (['declined'].includes(pay.status)) {
                    continue
                }
                balance = balance - parseFloat(pay.amount)
                const orderPaymentDetails = this.getOrderPaymentDetails(totals, pay)
                totals.push(orderPaymentDetails[0])
                totals.push(orderPaymentDetails[1])
            }

            if (balance < 0) {
                balance = 0
            }

            totals.push(<dd className={"col-sm-8 "} key={totals.length}>
                <div>
                    <FormattedMessage
                        id="quote.edit.numbers.balance"
                        defaultMessage="Balance"
                    />
                </div>
            </dd>)

            totals.push(<dd className={"col-sm-4"} key={totals.length}>
                <div>
                    <FormattedNumber
                        style="currency"
                        currency={this.state.total.attributes.currency}
                        value={balance}
                    />
                </div>
            </dd>)

        }

        return <dl className="row text-secondary text-right mb-0">
            {totals}
        </dl>
    }
}
export default injectIntl(DocumentPricingTableTotal)


// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/total.component.jsx